const STORAGE_KEY = "nkr_currency";

export const detectCurrency = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "ils" || stored === "usd") return stored;

    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    const lang = (navigator.language || "").toLowerCase();
    if (
      tz === "Asia/Jerusalem" ||
      tz === "Asia/Tel_Aviv" ||
      lang.startsWith("he") ||
      lang === "iw"
    ) {
      return "ils";
    }
  } catch (e) {
    // ignore
  }
  return "usd";
};

export const setCurrency = (cur) => {
  try {
    localStorage.setItem(STORAGE_KEY, cur);
  } catch (e) {
    // ignore
  }
};
